import { render, staticRenderFns } from "./PersonForm.vue?vue&type=template&id=4093c05c"
import script from "./PersonForm.vue?vue&type=script&lang=js"
export * from "./PersonForm.vue?vue&type=script&lang=js"
import style0 from "./PersonForm.vue?vue&type=style&index=0&id=4093c05c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports